import Cross from "../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import { Link } from "react-router-dom";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import FileUpload from "../MainAdmin/MainComponents/FileUpload";

const colourStyles = {
    control: (base) => ({ ...base, backgroundColor: "white" }),
    option: (base) => ({ ...base, backgroundColor: "white", color: "#000" }),
};

const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [{ align: [] }],
    ["clean"],
];

const AddJobApplyModal = ({ setShowModal, setRecheck, reCheck, onSaved, jobs, token, language = "fa" }) => {
    const isEnglish = language === "en";
    const text = (fa, en) => isEnglish ? en : fa;
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1, setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();

    const [allValues, setAllValues] = useState({
        JobId: null,
        Subject: "",
        CoverLetter: "",
        AttachPath: "",
    });
    const [allValuesError, setAllValuesError] = useState({
        JobId: false,
        Subject: false,
    });

    useEffect(() => {
        setAllValues({ JobId: null, Subject: "", CoverLetter: "", AttachPath: "" });
        setAllValuesError({ JobId: false, Subject: false });
    }, []);

    const blurHandler = (e) => {
        if (e.target) {
            if (e.target.value === "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: true });
            }
        }
    };
    const changeHandler = (e) => {
        if (e.target) {
            if (e.target.value !== "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: false });
            } else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true });
            }
            setAllValues({ ...allValues, [e.target.name]: e.target.value });
        }
    };
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addApply();
        }
    };

    const addApply = async () => {
        setSnipper(true);
        var res = allFull(allValues);
        if (res) {
            const dataUser = await axiosReq("Job/Apply", "post", {
                JobId: allValues.JobId?.value,
                Subject: allValues.Subject,
                CoverLetter: allValues.CoverLetter,
                Status: "Draft",
                AttachPath: allValues.AttachPath,
            });
            if (dataUser?.status === 200 || dataUser?.status === 204 || dataUser?.status === 201) {
                setRecheck(!reCheck);
                setShowModal(false);
                setSnipper(false);
                onSaved && onSaved();
            } else {
                setEroor(isEnglish ? "We could not save this application. Please review the fields and try again." : dataUser?.data);
                setShowErrorModalStep1(true);
                setSnipper(false);
            }
        } else {
            setEroor(text("لطفا موارد خواسته شده را وارد نمایید", "Please complete the required fields."));
            setShowErrorModalStep1(true);
            setSnipper(false);
        }
    };

    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        if (!obj.JobId) {
            updatedState.JobId = true;
            setAllValuesError({ ...allValuesError, ...updatedState });
            result = false;
        }
        if (obj.Subject === "") {
            updatedState.Subject = true;
            setAllValuesError({ ...allValuesError, ...updatedState });
            result = false;
        }
        return result;
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    };

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none" dir={isEnglish ? "ltr" : "rtl"}>
                <div className="relative w-[50%] my-5 mx-auto ">
                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{text("افزودن درخواست جدید", "Add a new application")}</p>
                            <button onClick={() => setShowModal(false)} aria-label="Close">
                                <Cross />
                            </button>
                        </div>

                        <div className="w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("شغل", "Job")}</span>
                                <Select
                                    options={jobs}
                                    value={allValues.JobId}
                                    onChange={(val) => {
                                        setAllValues({ ...allValues, JobId: val });
                                        setAllValuesError({ ...allValuesError, JobId: false });
                                    }}
                                    placeholder={text("انتخاب شغل", "Select a job")}
                                    isSearchable={true}
                                    styles={colourStyles}
                                />
                                {allValuesError?.JobId ? (
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        {text("لطفا یک شغل انتخاب کنید!", "Please select a job.")}
                                    </span>
                                ) : null}
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("موضوع", "Email subject")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="Subject"
                                    placeholder={text("موضوع را وارد کنید", "Enter an email subject")}
                                    value={allValues.Subject}
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    onKeyDown={handleKeyDown}
                                    onInput={maxLengthCheck}
                                    maxLength={300}
                                />
                                {allValuesError?.Subject ? (
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        {text("لطفا موضوع را وارد نمایید!", "Email subject is required.")}
                                    </span>
                                ) : null}
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("متن ایمیل", "Email body")}</span>
                                <ReactQuill
                                    theme="snow"
                                    value={allValues.CoverLetter}
                                    onChange={(val) => setAllValues({ ...allValues, CoverLetter: val })}
                                    modules={{ toolbar: toolbarOptions }}
                                    placeholder={text("متن را اینجا بنویسید", "Write your email here")}
                                    style={{ direction: "ltr", textAlign: "left" }}
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("پیوست", "Attachment")}</span>
                                {token ? (
                                    <FileUpload
                                        token={token}
                                        language={language}
                                        setPhoto={(val) => setAllValues({ ...allValues, AttachPath: val })}
                                    />
                                ) : (
                                    <p className="text-[12px] text-mainColor2">{text("برای آپلود فایل وارد شوید", "Sign in to upload a file")}</p>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}>
                                <p className="text-[15px] font-IRANYekanBold mx-[12px]">{text("بستن", "Close")}</p>
                            </button>
                            <button
                                onClick={addApply}
                                className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"
                            >
                                <p className="text-[15px] text-white font-IRANYekanBold">{snipper ? "..." : text("ثبت", "Save")}</p>
                            </button>
                        </div>
                    </div>
                </div>

                {showErrorModalStep1 ? (
                    <>
                        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">
                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold text-red">{text("درخواست اشتباه!", "Unable to save")}</span>
                                    </div>
                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm leading-relaxed">{error}</p>
                                    </div>
                                    <div className="flex items-center justify-end border-solid border-slate-200 rounded-b">
                                        <Link
                                            className="text-white mx-4 mb-2 rounded-md shadow-blueShadow bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            {text("فهمیدم", "Got it")}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
            </div>

            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
};

export default AddJobApplyModal;
